var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"is-user-avatar"},[_c('img',{attrs:{"src":_vm.newUserAvatar,"alt":_vm.userName}})])}
var staticRenderFns = []

export { render, staticRenderFns }